/**
 * United States first (aligns with isPrimaryCountryUS key/value rules), then A–Z by display `value`.
 */
export function sortCountryListWithUnitedStatesFirst(
  rows: { key?: string; value?: string }[] | null | undefined
): { key: string; value: string }[] {
  const list: { key: string; value: string }[] = (rows || [])
    .map(r => ({
      key: String(r.key ?? '').trim(),
      value: String(r.value ?? '').trim()
    }))
    .filter(r => r.key.length > 0 && r.value.length > 0);

  const isUnitedStates = (c: { key: string; value: string }): boolean => {
    if (c.key === 'US' || c.key === 'USA') {
      return true;
    }
    return c.value.toLowerCase().includes('united states');
  };

  const byValue = (a: { key: string; value: string }, b: { key: string; value: string }) =>
    a.value.localeCompare(b.value, undefined, { sensitivity: 'base' });

  const usIndex = list.findIndex(isUnitedStates);
  if (usIndex === -1) {
    return [...list].sort(byValue);
  }
  const us = list[usIndex];
  const rest = list.filter((_, i) => i !== usIndex).sort(byValue);
  return [us, ...rest];
}
